import React from "react";
import { Facebook, Instagram, Twitter, Youtube, Linkedin, MessageCircle, Send } from "lucide-react";

const DEFS = [
  ["facebook", Facebook, "Facebook"],
  ["instagram", Instagram, "Instagram"],
  ["twitter", Twitter, "X (Twitter)"],
  ["youtube", Youtube, "YouTube"],
  ["linkedin", Linkedin, "LinkedIn"],
  ["whatsapp", MessageCircle, "WhatsApp"],
  ["telegram", Send, "Telegram"],
];

export const SocialLinks = ({ social, className = "" }) => {
  const items = DEFS.filter(([k]) => social && social[k] && social[k].trim());
  if (items.length === 0) return <p className="text-xs text-slate-500">Social links coming soon.</p>;
  return (
    <div className={`flex flex-wrap gap-3 ${className}`} data-testid="social-links">
      {items.map(([k, Icon, label]) => (
        <a key={k} href={social[k]} target="_blank" rel="noopener noreferrer" aria-label={label}
          data-testid={`social-${k}`}
          className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-700 text-slate-300 transition-colors hover:border-emerald-500/50 hover:text-emerald-400">
          <Icon className="h-4 w-4" />
        </a>
      ))}
    </div>
  );
};
